import React, { useState } from "react"
import { Badge, Button } from "react-bootstrap"

import { fieldLabel } from "@/onboarding/features/product/models/fieldLabels"

import PendingFieldPermissionChangesModal from "@/onboarding/features/bidding/components/PendingFieldPermissionChangesModal"
import { flagLabel } from "@/onboarding/features/bidding/flagOptions"
import {
  changedTours,
  currentPermissionState,
} from "@/onboarding/features/bidding/models/fieldStates"
import { PermissionFlag, TourFieldPermissions } from "@/onboarding/features/bidding/types"

type Props = {
  selectedTours: TourFieldPermissions[]
  fieldName: string
  permissionFlag: PermissionFlag
  pickedPermissionValue: boolean | undefined
  onReset: () => void
}

const SelectedToursPermissionStatus = ({
  selectedTours,
  fieldName,
  permissionFlag,
  pickedPermissionValue,
  onReset,
}: Props): JSX.Element | null => {
  const [reviewing, setReviewing] = useState(false)

  if (pickedPermissionValue === undefined) {
    if (currentPermissionState(selectedTours, fieldName, permissionFlag).mixed) {
      return (
        <Badge bg="light" text="dark">
          Mixed
        </Badge>
      )
    }

    return null
  }

  const changed = changedTours(selectedTours, fieldName, permissionFlag, pickedPermissionValue)

  if (changed.length === 0) {
    return null
  }

  return (
    <span className="d-flex align-items-center gap-2 small">
      <Button
        variant="warning"
        size="sm"
        className="py-0"
        aria-label={`${fieldLabel(fieldName)}: ${flagLabel(permissionFlag, pickedPermissionValue)}, changes ${changed.length} of ${selectedTours.length} tours`}
        onClick={() => setReviewing(true)}
      >
        Changes {changed.length} of {selectedTours.length} tours
      </Button>
      <Button variant="link" size="sm" className="p-0" onClick={onReset}>
        Reset
      </Button>
      <PendingFieldPermissionChangesModal
        show={reviewing}
        onHide={() => setReviewing(false)}
        changes={[{ fieldName, permissionFlag, pickedPermissionValue }]}
        tours={selectedTours}
      />
    </span>
  )
}

export default SelectedToursPermissionStatus
